import Hero from "../components/hero";
import SeoMeta from "../components/seo-meta";
import config from "../config";
import { getSEOPageProps } from "../lib/seo";

import styles from "./policy.module.scss";

export default function CopyrightPage({ seo }) {
  return (
    <div className="container">
      <SeoMeta {...seo} />
      <Hero title="Notice and Procedure for Copyright Infringement Claims" />

      <div className={styles.Policy}>
        <section className={styles.Intro}>
          <p>
            East Room Holding Corp. and its affiliates (collectively, “East
            Room”) respects the intellectual property of others. It is East
            Room’s policy, in appropriate circumstances and at its discretion,
            to disable access to any content and/or terminate services to users
            who repeatedly infringe or are repeatedly charged with infringing
            the copyrights or other intellectual property rights of others.
          </p>

          <p>
            In accordance with the Digital Millennium Copyright Act and in
            recognition of various international copyright laws, East Room will
            respond expeditiously to claims of copyright infringement committed
            by a third party using the East Room website, or other online or
            mobile network, accessible through a mobile device or other type of
            device (the “Sites”) that are reported to East Room’s Designated
            Copyright Agent, identified below (the “DMCA Designated Agent”).
          </p>

          <p>
            If you are a copyright owner, are authorized to act on behalf of
            one, or authorized to act under any exclusive right under copyright,
            please report alleged copyright infringements taking place on or
            through the Sites by delivering the information identified below, in
            writing, to the DMCA Designated Agent:
          </p>

          <p>
            An electronic or physical signature of the copyright owner or the
            agent authorized to act on behalf of the copyright owner;
          </p>

          <ul>
            <li>
              A detailed description of the copyrighted work that you claim has
              been infringed, including any registration information;
            </li>
            <li>
              A detailed description of where the material that you claim is
              infringing is located, e.g., eastroom.com website;
            </li>
            <li>Your name, address, telephone number, and e-mail address;</li>
            <li>
              A statement by you that you have a good faith belief that the
              disputed use is not authorized by the copyright owner, its agent,
              or the law;
            </li>
            <li>
              A statement by you, made under penalty of perjury, that the above
              information in your notice is accurate and that you are the
              copyright owner or agent authorized to act on behalf of the
              copyright owner.
            </li>
          </ul>

          <p>
            Notices of claims of copyright infringement can be sent to East
            Room’s DMCA Designated Agent at:
          </p>

          <p>
            <strong>
              East Room Holding Corp. <br />
              <br />
              Legal Department - Intellectual Property Team
              <br />
              <br />
              ATTN: DMCA Designated Agent
              <br />
              <br />
              9 Davies, Toronto, ON, Canada, M4M 1G3
              <br />
              <br />
              Email: info@eastroom.com
            </strong>
          </p>

          <p>
            Upon receipt of the Notice as described below, East Room will take
            whatever action, in its sole discretion, it deems appropriate,
            including removal of the challenged material from the Sites.
          </p>

          <p>
            Please note that this procedure is exclusively for notifying East
            Room that your copyrighted material has been infringed.
            Communications unrelated to copyright use or infringement will be
            discarded.
          </p>
        </section>
      </div>
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {
      seo: await getSEOPageProps({ resolvedUrl: "/copyright" })
    },
    revalidate: config.ISR_TIMING
  };
}
